import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DateRangeField from '@/modules/common/components/DateRangeField';
import AutocompleteMultilineField from '@/modules/common/components/AutocompleteMultilineField';
import Button from "@/modules/common/components/Button";

const Form = (props) => {
    return (
        <form id="form-settings-resend-postbacks" onSubmit={props.onSubmit}>
            <DateRangeField value={props.values.date}
                            setValue={(value) => props.setValues({...props.values, date: value})}
            />
            <div className="fields">
                <AutocompleteMultilineField options={props.cfgOffers.map((cfgOffer) => cfgOffer.offer_name)}
                                            value={props.values.offers}
                                            setValue={(value) => props.setValues({...props.values, offers: value})}
                                            label="Офферы"
                />
                <AutocompleteMultilineField options={props.affiliates.map((affiliate) => affiliate.affiliate_name)}
                                            value={props.values.affiliates}
                                            setValue={(value) => props.setValues({...props.values, affiliates: value})}
                                            label="Партнеры"
                />
            </div>
            <div className="submit">
                <Button type="submit" disabled={props.disabled}>
                    Запустить
                </Button>
            </div>
        </form>
    )
}

Form.propTypes = {
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
}

let Component = Form;

export default connect(
    (state) => ({
        cfgOffers: state.cfg.offers,
        affiliates: state.affiliates,
    }),
    null
)(Component);
